var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.333 9.833.627-.626a1 1 0 0 0 0-1.414l-.627-.626",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 8.5H8.667M4 13.833a2.667 2.667 0 0 1-2.667-2.666V5.833A2.667 2.667 0 0 1 4 3.167m0 10.666a2.667 2.667 0 0 0 2.667-2.666V5.833A2.667 2.667 0 0 0 4 3.167m0 10.666h5.333A2.667 2.667 0 0 0 12 11.167m-8-8h5.333A2.667 2.667 0 0 1 12 5.833",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgLogout;